import { Suspense } from 'react';
import { AreaComponent } from '../../AreaComponent/AreaComponent';
import { FaqSection } from '../../FaqSection/FaqSection';
import { SportsbookPageContent } from './SportsbookPageContent';

function SportsbookPageFallback() {
  return (
    <div className="pt-4 pb-10 mx-[var(--ll-container-padding)] flex flex-col gap-6">
      <div className="overflow-x-hidden">
        <AreaComponent slug="sportsbook" area="TOP" />
      </div>
      <div className="w-full min-h-screen bg-background" data-testid="sportsbook-widget" />
      <FaqSection className="mt-6" namespace="sportsbook.faq" data-track-container="SEO" />
    </div>
  );
}

function SportsbookPage() {
  return (
    <div className="min-h-screen bg-background">
      <Suspense fallback={<SportsbookPageFallback />}>
        <SportsbookPageContent />
      </Suspense>
    </div>
  );
}

export { SportsbookPage };
